import CircularBar from './CircularBar';

export default CircularBar;
